export const ERRORS = {
  TRACKING_NUMBER_EXISTS: $localize`! Tracking Number Already Exists`,
  INVALID_ACCOUNT: $localize`! Invalid Shipper Account`,
  TRACKING_NO_INVALID: $localize`! Invalid Tracking Number`,
  MISSING_SHIPPER_ID: $localize`! Missing Shipper ID. Click on pencil icon to complete`,
  BAD_TRACKING_NUMBER: $localize`! Tracking number invalid`,
  INTERCEPT_ERROR: $localize`! Tracking Number either Intercepted or On Road Exception`,
  FULL_BATCH: $localize`! You may not add any more tracking numbers to this batch`,
  INTERCEPTED_TRACKING_NUMBER: $localize`DO NOT DELIVER! Package Intercept: `,
  RETURN_TO_CENTER: $localize`Return Package to Center`,
  REQUIRED_COD: $localize`! Required`,
  COD_GREATER_THAN_ZERO: $localize`! COD amount must be greater than 0.`,
  DO_NOT_LOAD: $localize`Do not Process. Return to UPS!`.toUpperCase(),
};
